module.exports = __webpack_public_path__ + "img/sunshine_600.e79ef01b.png";